// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WkKGS2HyVc1DsMoU0KM9 {
  border: none !important;
}`, "",{"version":3,"sources":["webpack://./packages/common/utils/components/src/lib/FormClearButton/style.module.scss"],"names":[],"mappings":"AAAA;EACE,uBAAA;AACF","sourceRoot":""}]);
// Exports
export var noBorder = `WkKGS2HyVc1DsMoU0KM9`;
export default ___CSS_LOADER_EXPORT___;
